/**
 * @file Module to describe model of table's data.
 * Only to be used by Table.js, not as a stand-alone component.
 * @since 3.7.0
 */

/**
 * Class representing data model.
 */
export default class TableModel {
  constructor(table, data) {
    this.component = table;
    this.setData(data);
  }

  setData(data = []) {
    this.initialData = data;
    this.data = this._processData(this.initialData);
    this.sort();
  }

  addData(newData) {
    if (newData) {
      this.data.push({...newData, selected: newData.selected || false, indexOriginal: this.data.length});
      this.sort();
    }
  }

  deleteByIndex(index) {
    this.data.splice(index, 1);
    this.setDisplayedData();
  }

  selectByIndex(index) {
    this.data[index].selected = true;
  }

  deselectByIndex(index) {
    this.data[index].selected = false;
  }

  selectAll() {
    this.data.forEach((item) => item.selected = true);
  }

  deselectAll() {
    this.data.forEach((item) => item.selected = false);
  }

  sort() {
    if (!this.component.currentSort.length) {
      return;
    }

    const key = this.component.currentSort[0].key;
    const direction = this.component.currentSort[0].dir;

    // Reset sort to make sure previous sorting does not affect new order
    this._resetSort();

    if (key) {
      if (direction === 'asc') {
        this._sortAsc(key);
      }

      if  (direction === 'desc') {
        this._sortDesc(key);
      }
    }
  }

  _processData(data) {
    return data.map((d, i) => ({...d, selected: d.selected || false, indexOriginal: i}));
  }

  /**
   * Subtract data to display.
   * Example. Rows per page: 10
   * 1: [0, 10) 2: [10, 20) 3: [20, 30)...
   */
  setDisplayedData() {
    if (this.component.pagination) {
      const rowsPerPage = this.component.pagination.state.numPerPage;
      const currentPage = this.component.pagination.state.currentPage;
      // "start" included, "end" not included.
      const start = rowsPerPage * (currentPage - 1);
      const end = rowsPerPage * currentPage;

      this.displayedData = this.data.slice(start, end);
    } else {
      this.displayedData = this.data;
    }
  }

  _sortAsc(key) {
    this.data.sort((a, b) => {
      if (a[key] < b[key]) {
        return -1;
      }

      if (a[key] > b[key]) {
        return 1;
      }

      return 0;
    });
  }

  _sortDesc(key) {
    this.data.sort((a, b) => {
      if (a[key] < b[key]) {
        return 1;
      }

      if (a[key] > b[key]) {
        return -1;
      }

      return 0;
    });
  }

  _resetSort() {
    // this.data = [...this.initialData];
    this.data.sort((a, b) => a.indexOriginal - b.indexOriginal);
  }
}
